import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetInterestQuery } from '../../../../../../redux/services/fj_interests.jsx';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import { Spinner } from '../../../../../common/index.jsx';

const FjMyInterestDetail = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  const { data: interest, isLoading } = useGetInterestQuery(id);

  const pageTitle = t('Poskytnuté údaje a informácie o pracovnej ponuke');

  useEffect(() => {
    document.title = pageTitle + ' - FRI.jobs';
  }, [pageTitle]); // Runs on mount

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS title={pageTitle} backUrl={-1} backUrlTooltip={t('Späť')} />
      <FjMyInterestDetail interest={interest} />
    </>
  );
};

export default FjMyInterestDetail;
